import { Map } from 'immutable';

import * as ActionTypes from '../constants/ActionTypes';

const initialState = Map({
    total: 1,
    averageScore: 4.4,
    reviewsCount: 21,

    error: false,
    errorMessage: '',
});

const reducerNavigation = (state = initialState, action) => {
    if (action.type === ActionTypes.UPDATE_STATS) {
        const newState = Map({
            total: action.stats.total,
            reviewsCount: action.stats.reviewsCount,
            averageScore: action.stats.averageScore.toFixed(1),
            error: false,
        });

        return state.merge(newState);
    }

    if (action.type === ActionTypes.UPDATE_STATS_ERROR) {
        const errorState = initialState.merge(Map({
            error: true,
            errorMessage: action.error,
        }));

        return state.merge(errorState);
    }

    return state;
};

export default reducerNavigation;



// WEBPACK FOOTER //
// ./src/reducers/stats.js